/*
 * Cowlendar variant-change bridge
 * --------------------------------
 * Why this exists:
 * The Momentum theme's <product-form> element updates the selected variant
 * WITHOUT firing a native "change" event on the [name="id"] fields. It only
 * emits its own private "ARMADA:VARIANT:CHANGE" event and silently rewrites
 * the URL via history.pushState (which does not fire popstate).
 *
 * Apps like Cowlendar detect the selected variant by listening for a native
 * "change" on the product form's [name="id"] field (and/or the ?variant= URL).
 * Because the theme never fires that signal, Cowlendar only ever sees the FIRST
 * variant loaded on the page, so it always shows the first variant's service.
 *
 * This bridge listens for the theme's ARMADA:VARIANT:CHANGE event and re-broadcasts
 * it as the standard signals variant-aware apps expect:
 *   1. Sets every [name="id"] field to the new variant id and fires a real,
 *      bubbling "change" (and "input") event on it.
 *   2. Dispatches a few widely-used custom variant-change events as a fallback.
 *
 * It does not modify any theme file and makes no visual change. It only reacts
 * when a variant actually changes on a product page.
 */
(function () {
  'use strict';

  var reentrant = false;

  function syncVariant(variantId, variant) {
    if (!variantId || reentrant) return;
    reentrant = true;

    try {
      // 1) Point every variant-id field at the newly selected variant and fire
      //    a genuine change event so listening apps (Cowlendar) pick it up.
      var idFields = document.querySelectorAll('input[name="id"], select[name="id"]');
      idFields.forEach(function (field) {
        // For <select>, make sure a matching <option> exists before assigning.
        if (field.tagName === 'SELECT') {
          var hasOption = Array.prototype.some.call(field.options, function (o) {
            return String(o.value) === String(variantId);
          });
          if (!hasOption) return;
        }

        if (String(field.value) !== String(variantId)) {
          field.value = variantId;
        }

        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // 2) Fallback: broadcast common variant-change events some apps listen for.
      var detail = { variant: variant || null, variantId: variantId };
      ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
      });
    } catch (err) {
      // Never let this break the page.
      if (window.console && console.warn) {
        console.warn('[cowlendar-variant-bridge] ', err);
      }
    } finally {
      reentrant = false;
    }
  }

  document.addEventListener('ARMADA:VARIANT:CHANGE', function (e) {
    var d = e && e.detail ? e.detail : {};
    syncVariant(d.variantId, d.variant);
  });
})();
